import { render, staticRenderFns } from "./Evento_deporte_prematch2.vue?vue&type=template&id=bf2df2dc&scoped=true"
import script from "./Evento_deporte_prematch2.vue?vue&type=script&lang=js"
export * from "./Evento_deporte_prematch2.vue?vue&type=script&lang=js"
import style0 from "./Evento_deporte_prematch2.vue?vue&type=style&index=0&id=bf2df2dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf2df2dc",
  null
  
)

export default component.exports